import React, { useEffect, useState } from "react";
import { Search, getFloorlist } from "adminApi/RoomStatusApi/RoomStatusApi";
import Spinner from "Common/Globle/Spinner";
import RoomStatusForm from "./Components/RoomStatusForm";
import fields from "./json/RoomStatusFields.json";
import useFormChange from "Hooks/useFormChange";
import useDebouncedValue from "Common/DataTable/useDebouncedValue";
import useFetchAllData from "Hooks/useFetchAllData";
import RoomStatusTable from "./Components/RoomStatusTable";

const RoomStatus = () => {
    const { formdata } = fields;
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});
    const { values, handleChange } = useFormChange(initialValues);
    const { data: FloorListOptions, loading: loadingFloor } = useFetchAllData(getFloorlist);
    const [loading, setLoading] = useState(false);
    const [roomData, setRoomData] = useState([]);
    const debouncedSearch = useDebouncedValue(values.search, 500);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const fetchRoomStatus = async () => {
        try {
            setLoading(true);
            const res = await Search({
                date: values.date,
                floor: values.floor,
                status: values.status,
                search: debouncedSearch,
            });
            setRoomData(res?.data || []);
        } catch (err) {
            console.error("Search error:", err);
        } finally {
            setLoading(false);
        }
    };

    //  Trigger search
    useEffect(() => {
        fetchRoomStatus();
    },
        [
            values.date,
            values.floor,
            values.status,
            debouncedSearch
        ]
    );

    return (
        <>
            {(loading || loadingFloor) && <Spinner isSpinner />}
            <RoomStatusForm
                fields={formdata}
                values={values}
                handleChange={handleChange}
                handleSubmit={(e) => e.preventDefault()}
                loading={loading}
                title="Room Status"
                FloorListOptions={FloorListOptions}
            />
            <RoomStatusTable data={roomData} />
        </>
    );
};

export default RoomStatus;
